module.exports = __webpack_public_path__ + "img/step_1.fb1a4279.png";